import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/utils/Directive/vant.js';

import '@/assets/css/transition.css';

import '@/utils/Filters/index';

import '@/utils/Directive/index';

import Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.css';
Vue.prototype.$swiper = Swiper;

import filterXSS from 'xss'
Vue.prototype.$filterXSS = (params) => filterXSS(params)

import Layer from '@/utils/Layer/index';
import '@/utils/Layer/style.css';
Vue.prototype.$layer = Layer;

const Bus = {
  install: () => {
    Vue.prototype.$Bus = new Vue();
  }
};
Vue.use(Bus);

require('@/utils/arms');
const Cookie = require('js-cookie');
Vue.prototype.$cookie = Cookie;
require('@/utils/deviceId');
const PhotoSwipe = require('vue-photoswipe.js');
require('vue-photoswipe.js/dist/static/css/photoswipe.css');
Vue.use(PhotoSwipe.default, {
  wechat: window.wx,
  pswpOptions: {
    showShare: false,
    showClose: true,
    showFullscreen: false,
    showZoom: false
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
